export enum Status {
  ACTIVE = 'ACTIVÉ',

  DESACTIVE = 'DÉSACTIVÉ',

  ARCHIVE = 'ARCHIVÉ',
}
